// extracted by mini-css-extract-plugin
export default {"notifications":"DashboardNotifications_notifications__FHguJ"};